import React from "react";
import {FaRegUser} from "react-icons/fa";
import {MdMailOutline} from "react-icons/md";
import useSalesRep from "./useSalesRep";
import TitleAndSubTitle from "../TitleAndSubTitle";
import "./SalesRep.css";
import InfoMessageNote from "../messageNote/InfoMessageNote";
import {LoadingAnimationContainer} from "../../../../utils/loading_animation";

function EmailDisplay({email}) {
    return <div className="flex items-center gap-2">
        <MdMailOutline className="w-5 h-5"/>
        <a href={`mailto:${email}`} className="font-semibold">{email}</a>
    </div>;
}

function NoSalesRepDisplay() {
    return <InfoMessageNote
        className="flex flex-col gap-2.5 font-semibold mt-8"
        display={
            <>
                Votre entreprise n'a pas encore de référent commercial attitré. Nous vous en attribuerons un dans les plus brefs délais. En
                attendant, notre équipe reste à votre disposition et peut être contactée en utilisant l'adresse email suivante :
                <EmailDisplay email="contact@virteem-companion.fr"/>
            </>
        }/>;
}

function SalesRepDisplay({salesRep}) {
    return <>
        <img src={salesRep.profile_picture ? `data:image/png;base64,${salesRep.profile_picture}` : "/images/pa.png"}
             className="sales-rep-img rounded-full"
             alt={`${salesRep.first_name} ${salesRep.last_name}`}
             data-tooltip-content={`Photo de ${salesRep.first_name} ${salesRep.last_name}`}
             data-tooltip-id="main-tooltip"/>
        <div className="flex-wrap flex-col space-y-4">
            <div className="flex items-center gap-2">
                <FaRegUser className="w-5 h-5 text-black"/>
                <div className="font-semibold">{`${salesRep.first_name} ${salesRep.last_name}`}</div>
            </div>
            <EmailDisplay email={salesRep.email}/>
        </div>
    </>;
}


export default function SalesRep() {
    // États pour la gestion des données
    const [{salesRep, isLoading}] = useSalesRep();

    return (
        <main className="sales-rep">
            <TitleAndSubTitle h1="Votre contact Virteem Companion" h2="Contactez votre Référent Virteem Companion"/>
            <br/>

            <p>Si vous avez des questions ou si vous avez besoin
                d'assistance, n'hésitez pas à contacter votre interlocuteur chez Virteem.
            </p>
            <p>Nous sommes là pour vous aider !</p>
            <br/>

            <hr/>

            <div className="flex gap-4 flex-wrap flex-row items-center justify-center">
                {isLoading ? <LoadingAnimationContainer/> : (salesRep == null ? <NoSalesRepDisplay/> : <SalesRepDisplay salesRep={salesRep}/>)}
            </div>
            <br/>

        </main>
    );
}
